import { Component } from '@angular/core';

@Component({
    selector: 'app-error-form',
    templateUrl: './error-form.component.html',
    styleUrls: ['./error-form.component.scss'],
    standalone: false
})
export class ErrorFormComponent {

}
